import {
  Accordion,
  Box,
  Button,
  IconButton,
  Select,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledbBoxContainer = styled(Box)(() => ({
  position: 'absolute',
  textAlign: 'center',
  top: '49vh',
  left: '51%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: '#FAFCFF',
  padding: '20px',
  width: '940px',
  borderRadius: '16px',
  height: '640px',
  display: 'block',
  overflow: 'auto',
}));

export const Title = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: '18px',
  textAlign: 'left',
  margin: '8px 16px 16px',
}));

export const CoverageBox = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  padding: '10px 10px 8px 0',
}));

export const CoverageDeleteButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.secondary.main,
  height: '53px',
  width: '53px',
  border: `1px solid ${theme.palette.secondary.main}`,
  borderRadius: '12px',
}));

export const SaveCoverageButton = styled(Button)(({ theme }) => ({
  width: '210px',
  display: 'flex',
  gap: '10px',
  borderRadius: '30px',
  fontWeight: '600',
  height: '48px',
  color: '#FAFCFF',
  backgroundColor: theme.palette.secondary.main,
  fontFamily: 'Montserrat',
  textTransform: 'lowercase',
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  width: '210px',
  display: 'flex',
  gap: '10px',
  border: `1px solid ${theme.palette.secondary.main}`,
  borderRadius: '30px',
  color: theme.palette.secondary.main,
  fontFamily: 'Montserrat',
  fontWeight: '600',
  height: '48px',
  backgroundColor: '#FAFCFF',
  textTransform: 'lowercase',
}));

export const ScrollableGrid = styled(Box)(() => ({
  height: '406px',
  border: '1px solid #B9BABB',
  borderRadius: '6px',
  width: '872px',
  overflowY: 'scroll',
  margin: '0px auto',
  padding: '4px',
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#8B8C8E',
    borderRadius: '4px',
  },
}));

export const CustomAccordion = styled(Accordion)(({ theme }) => ({
  width: '90%',
  backgroundColor: 'transparent !important',
  boxShadow: 'none',
  '&:before': {
    display: 'none',
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: theme.palette.secondary.main,
    marginLeft: '60px',
  },
  '& .MuiAccordionSummary-content': {
    margin: '0 !important',
    backgroundColor: 'transparent',
  },
  '& .MuiAccordionSummary-root': {
    backgroundColor: 'transparent',
    minHeight: '48px !important',
    '&.Mui-expanded': {
      backgroundColor: 'transparent',
      minHeight: '48px !important',
    },
  },
}));

export const StyledSelectUf = styled(Select)(({ theme }) => ({
  width: '100%',
  textAlign: 'start',
  fontSize: '14px',
  '&.MuiOutlinedInput-root': {
    borderRadius: 16,
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.common.grey,
    },
  },
}));

export const AddNewPoleButton = styled(Button)(({ theme }) => ({
  width: '184px',
  display: 'flex',
  gap: '10px',
  border: `1px solid ${theme.palette.secondary.main}`,
  borderRadius: '30px',
  color: theme.palette.secondary.main,
  fontWeight: '600',
  height: '48px',
  backgroundColor: '#FAFCFF',
  textTransform: 'lowercase',
  '&:disabled': {
    color: theme.palette.secondary.main,
  },
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.secondary.main,
  height: '51px',
  width: '51px',
  border: `1px solid ${theme.palette.secondary.main}`,
  borderRadius: '12px',
  '&.Mui-disabled': {
    color: 'rgba(0, 0, 0, 0.26)',
    border: '1px solid rgba(0, 0, 0, 0.12)',
  },
}));
